import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { Loading, ProfileProductsView } from '@/components/common';
import { adminKYCApi } from '@/api';
import { useSelector } from 'react-redux';

export const InvestorProducts = () => {
  const { id } = useParams();
  const investor = useSelector((state) => state.investor);
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['getInvestorProducts'],
    queryFn: () => adminKYCApi.getInvestorProducts(id),
    refetchInterval: 60000,
    refetchOnWindowFocus: true
  });

  if (isLoading) return <Loading />;

  if (!isLoading) {
    return (
      <ProfileProductsView data={data} investor={investor} refetchProducts={refetch} adminView />
    );
  }

  return null;
};
